import { pricesURL } from '@lessonnine/babbel-urls.js';

import { mergeUrlParams } from 'src/dataLayer/localData/queryParams';
import { getReturnToUrl } from 'src/dataLayer/localData/queryParams/returnToURLHelpers';
import { RUNTIME_ENVIRONMENT, CLIENT, SIGN_IN_URL, LOCALE } from 'src/dataLayer/env';
import { environmentMapping } from 'src/viewLayer/helpers/environmentMapping';
import { RedirectArgsType } from './types';

export const redirect = (url: string, delay = 200): ReturnType<typeof setTimeout> =>
  setTimeout(() => window.location.assign(url), delay);

const getDeviceType = (): string => {
  switch (CLIENT.osName) {
  case 'iOS':
    return 'ios';
  case 'Android':
    return 'android';
  default:
    return 'default';
  }
};

const getReturnToURLFromConfig = ({
  nodeConfig,
  learnLang,
  queryParams
}: RedirectArgsType): string => {
  if (nodeConfig?.url) {
    const environmentConfig = environmentMapping[RUNTIME_ENVIRONMENT] || environmentMapping.test;
    const { protocol, topLevelDomain } = environmentConfig;
    const deviceType = getDeviceType();
    const returnToURLFromConfig = nodeConfig.url[deviceType] || nodeConfig.url.default;
    const interpolatedURL =
      returnToURLFromConfig.replace('%{protocol}', protocol).replace('%{topLevelDomain}', topLevelDomain).replace('%{locale}', LOCALE);

    return mergeUrlParams(interpolatedURL, queryParams);
  }
  return pricesURL(learnLang);
};

export const getRedirectNodeReturnToUrl = ({
  nodeConfig,
  learnLang,
  queryParams
}: RedirectArgsType): string => {
  // we need the second argument to be null, otherwise getReturnToUrl will return the fallback url
  // eslint-disable-next-line unicorn/no-null
  const returnToURLFromsearchParams = getReturnToUrl(queryParams, null);
  return returnToURLFromsearchParams || getReturnToURLFromConfig({ nodeConfig, learnLang, queryParams });
};

export const getAutoLoginReturnToUrl = ({
  nodeConfig,
  learnLang,
  queryParams,
  signinToken
}: RedirectArgsType): string => {
  const returnToURL = getRedirectNodeReturnToUrl({ nodeConfig, learnLang, queryParams });
  const loginUrlWithReturnTo = `${SIGN_IN_URL}?return_to=${encodeURIComponent(returnToURL)}`;
  return mergeUrlParams(loginUrlWithReturnTo, { auth_token: signinToken });
};
